export const defaultShopRoute = '/shop/';

export const checkRedirectNecessary = (pageParams: array|undefined): false|string => {
  if (pageParams) {
    const baseRoute = pageParams[0];
    const onlyWithChildRoutes = ['category', 'sound-designer', 'tag'];

    if (onlyWithChildRoutes.includes(baseRoute)) {
      return pageParams.length === 1
        ? defaultShopRoute
        : false;
    } else if (baseRoute !== '') {
      return defaultShopRoute;
    }
  }
}

export const parseParams = (pageParams: array): Record<string, string|array> => {
  let uri = '';
  let routeCategories = [];
  let routeTags = [];

  // sound-effects, software, sound-designer, category
  const rootPageType = pageParams[0];

  if (rootPageType === 'category') {
    pageParams.forEach((categoryName, index) => {
      // Filter out names that are an empty string. Nuxt interprets / at the end as an empty string
      // Ignores first param because it's the page type and not a category
      if (categoryName && index > 0) {
        routeCategories.push(categoryName);
      }
    });

    // only add last / child category to search query
    uri = `&category=${routeCategories[routeCategories.length - 1]}`;
  } else if (rootPageType === 'sound-designer') {
    uri = `&vendor=${pageParams[1]}`;
  } else if (rootPageType === 'tag') {
    pageParams.forEach((tagName, index) => {
      // Filter out names that are an empty string. Nuxt interprets / at the end as an empty string
      // Ignores first param because it's the page type and not a category
      if (tagName && index > 0) {
        routeTags.push(tagName);
      }
    });

    uri = `&tag=${routeTags[routeTags.length - 1]}`;
  }

  return {
    uri,
    routeCategories,
  };
}

export const buildQueryParams = (urlParams, pageParams, queryParams) => {
  const responseParams = {};

  const pageType = pageParams[0];

  if (pageType === 'sound-designer') {
    const vendorSlug = pageParams[1];

    queryParams.push(`vendor=${vendorSlug}`);
  } else if (pageType === 'software') {
    queryParams.push('search-for=software');
  } else if (pageType === 'sound-effects') {
    queryParams.push('search-for=sound-effects');
  }

  // add all additional filters based on query params
  // Using this approach to make sure that all query params are only available once
  Object.keys(urlParams).forEach((queryParam) => {
    let paramValue = urlParams[queryParam];

    // if category is set because of the url then append additional categories
    if (responseParams[queryParam]) {
      responseParams[queryParam] = `${responseParams[queryParam]},${paramValue}`;
    } else {
      responseParams[queryParam] = paramValue;
    }
  });

  // convert object to array, joining param and value that are then used in the api query
  Object.keys(responseParams).forEach((param) => {
    queryParams.push(`${param}=${responseParams[param]}`);
  });

  return queryParams;
}
